<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">

      <!-- Col 1 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-input
          class="w-full"
          v-model="data_local.twitter"
          icon-pack="feather"
          icon="icon-twitter"
          :label="$t('profile.p15')"
          icon-no-border
          v-validate="'url:require_protocol'"
          name="twitter" />
          <span class="text-danger text-sm"  v-show="errors.has('twitter')">{{ errors.first('twitter') }}</span>

        <vs-input
          class="w-full mt-4"
          v-model="data_local.facebook"
          icon-pack="feather"
          icon="icon-facebook"
          :label="$t('profile.p16')"
          icon-no-border
          v-validate="'url:require_protocol'"
          name="facebook" />
          <span class="text-danger text-sm"  v-show="errors.has('facebook')">{{ errors.first('facebook') }}</span>

      </div>

      <!-- Col 2 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-input
          class="w-full"
          v-model="data_local.instagram"
          icon-pack="feather"
          icon="icon-instagram"
          :label="$t('profile.p17')"
          icon-no-border
          v-validate="'url:require_protocol'"
          name="instagram" />
        <span class="text-danger text-sm"  v-show="errors.has('instagram')">{{ errors.first('instagram') }}</span>

        <vs-input
          class="w-full mt-4"
          v-model="data_local.linkedin"
          icon-pack="feather"
          icon="icon-linkedin"
          :label="$t('profile.p18')"
          icon-no-border
          v-validate="'url:require_protocol'"
          name="linkedin" />
        <span class="text-danger text-sm"  v-show="errors.has('linkedin')">{{ errors.first('linkedin') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{($t('profile.p23'))}}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">{{($t('profile.p24'))}}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data (Also remvoe eslint-disable)
      // You can get data in "this.data_local"

      /* eslint-enable */

      console.log("local data", this.data_local);

      this.$store
        .dispatch("userManagement/updateUser", this.data_local)
        .then(res => {
          console.log("going to update tab account user", res);
          this.$vs.notify({
            color: "primary",
            title: i18n.t('notification.admin.user.updateSocialDetails.success.u1'),
            text:  i18n.t('notification.admin.user.updateSocialDetails.success.u2')
          });
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: i18n.t('notification.admin.user.updateSocialDetails.error.u1'),
            text:  i18n.t('notification.admin.user.updateSocialDetails.error.u2')
          });
        });
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
